<ul>
  <li *ngFor="let textBlock of textBlocks">
    <h4 *ngIf="textBlock.header">{{ textBlock.header }}</h4>
    <p *ngIf="textBlock.text" class="pb-3" [innerHTML]="textBlock.text"></p>
    <ul *ngIf="textBlock.paragraphs.length">
      <li *ngFor="let paragraph of textBlock.paragraphs">
          <p class="pb-3" [innerHTML]="paragraph"></p>
      </li>
    </ul>
  </li>
</ul>
